import React from 'react';

interface PageTransitionProps {
    children: React.ReactNode;
    className?: string;
}

/** Keep prerendered content visible and stable while the client hydrates. */
export function PageTransition({ children, className = '' }: PageTransitionProps) {
    return <div className={className}>{children}</div>;
}

interface FadeInProps {
    children: React.ReactNode;
    delay?: number;
    duration?: number;
    className?: string;
}

export function FadeIn({ children, delay = 0, duration = 0.5, className = '' }: FadeInProps) {
    void delay;
    void duration;
    return <div className={className}>{children}</div>;
}

interface StaggerContainerProps {
    children: React.ReactNode;
    staggerDelay?: number;
    className?: string;
}

export function StaggerContainer({ children, staggerDelay = 0, className = '' }: StaggerContainerProps) {
    void staggerDelay;
    return <div className={className}>{children}</div>;
}

export function StaggerItem({ children, className = '' }: { children: React.ReactNode; className?: string }) {
    return <div className={className}>{children}</div>;
}

interface SlideInProps {
    children: React.ReactNode;
    direction?: 'left' | 'right' | 'up' | 'down';
    delay?: number;
    className?: string;
}

export function SlideIn({ children, direction = 'up', delay = 0, className = '' }: SlideInProps) {
    void direction;
    void delay;
    return <div className={className}>{children}</div>;
}

interface HoverScaleProps {
    children: React.ReactNode;
    scale?: number;
    className?: string;
}

export function HoverScale({ children, scale = 1.05, className = '' }: HoverScaleProps) {
    return (
        <div className={`${className} hover-scale`} style={{ '--hover-scale': scale } as React.CSSProperties}>
            {children}
        </div>
    );
}
